import {
    assertIsNonEmptyString,
    assertIsNotBoolean,
    assertIsNotNull,
    assertIsNumber,
} from '../../lib/test-and-assert/assert-base';

/**
 * @constructor
 */
function SimpleCache(maxCacheTimeSeconds) {
    assertIsNumber(maxCacheTimeSeconds);

    this.maxCacheTimeSeconds = maxCacheTimeSeconds;
    this.data = {};
}

/**
 * Add/update data into cache.
 *
 * It is only meant for numbers, strings and object. if you try to cache null or bools the code
 * will explode!
 *
 * @param {string} id
 * @param {number|string|Object} data
 */
SimpleCache.prototype.setData = function (id, data) {
    assertIsNonEmptyString(id);
    assertIsNotNull(data);
    assertIsNotBoolean(data);

    this.data[id] = {
        time_ms: Date.now(),
        data: data,
    };
};

/**
 * Get data from cache. This returns either:
 *
 * - `null` if the id does not exist
 * - `false` if the data is expired
 * - The data if it is still fresh
 *
 * @param id
 *
 * @return {null|boolean|Object}
 */
SimpleCache.prototype.getData = function (id) {
    assertIsNonEmptyString(id);

    if (!this.data.hasOwnProperty(id)) {
        return null;
    }

    var ageInSeconds = (Date.now() - this.data[id].time_ms) / 1000.0;

    if (ageInSeconds > this.maxCacheTimeSeconds) {
        return false;
    }

    return this.data[id].data;
};

/**
 * This returns either:
 * - `null` if the id does not exist
 * - the data
 *
 * @param id
 *
 * @return {null|Object}
 */
SimpleCache.prototype.getDataEvenIfTooOld = function (id) {
    assertIsNonEmptyString(id);

    if (!this.data.hasOwnProperty(id)) {
        return null;
    }

    return this.data[id].data;
};

export { SimpleCache };
